import axios from "axios";
import { BASE_URL } from "../../_constants/urlConstants";
import { QMS } from "../../_constants/actionConstants";

const logError = (e) => console.error("ProDMS/QMS: Request failed with error:", e);

const qmsRolePermissionActions = {
  get: (proDmsUserId) => async (dispatch) => {
    dispatch({ type: QMS.PERMISSIONS.FETCH_FOR_USER });
    const apiEndpoint = BASE_URL + "/api/qms/QmsRolePermission/ForUser/" + proDmsUserId;
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({
        type: QMS.PERMISSIONS.FETCH_FOR_USER_FULFILLED,
        qmsRolePermissions: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.PERMISSIONS.FETCH_FOR_USER_REJECTED });
      logError(e);
    }
  },
  getPermissionScopesAndActions: () => async (dispatch) => {
    dispatch({ type: QMS.PERMISSIONS.FETCH_PERMISSION_SCOPES_ACTIONS });
    const apiEndpoint_ps = BASE_URL + "/api/qms/QmsRolePermission/PermissionScopes";
    const apiEndpoint_actions = BASE_URL + "/api/qms/QmsRolePermission/Actions";
    try {
      const [resPs, resActions] = await Promise.all([
        axios.get(apiEndpoint_ps),
        axios.get(apiEndpoint_actions),
      ]);

      dispatch({
        type: QMS.PERMISSIONS.FETCH_PERMISSION_SCOPES_ACTIONS_FULFILLED,
        permissionScopes: resPs.data,
        actions: resActions.data,
      });
    } catch (e) {
      dispatch({ type: QMS.PERMISSIONS.FETCH_PERMISSION_SCOPES_ACTIONS_REJECTED });
      logError(e);
    }
  },
};

function getAuthorizeLevelFunc(scopes, actions) {
  if (!scopes || !actions) return;
  const authorize = {};
  scopes.forEach((s) => {
    const scopeActions = {};
    actions.forEach((a) => {
      scopeActions[a.name] = (requestedLevel, authorizedLevel) =>
        requestedLevel >= authorizedLevel;
    });
    authorize[s.name] = scopeActions;
  });
  return authorize;
}

export default qmsRolePermissionActions;
